<template>
  <div class="category-detail-v2">
    <div class="container">
      <article v-if="(popular_brand.length || loading_popular_brand) && isParentCategory" class="popular-review">
        <header>
          <GFMP v-if="loading_popular_brand" :styles="{ ...fmpStyles.textHeader, width: '112px' }" />
          <h1 v-else>Featured Brand</h1>
        </header>
        <section>
          <div v-if="loading_popular_brand" style="display: flex; gap: 16px">
            <GFMP
              v-for="i in 6"
              :key="i"
              :wrapper-styles="{ flexGrow: 1 }"
              :styles="{ height: '86px', borderRadius: '8px' }"
            />
          </div>
          <template v-else>
            <template v-if="popular_brand.length">
              <div v-if="isDesktop">
                <carousel
                  :per-page="isDesktop ? 6 : 3"
                  :navigation-enabled="true"
                  navigation-next-label
                  navigation-prev-label
                  :pagination-enabled="false"
                  class="popular-brand-carousel"
                >
                  <slide v-for="(currentBrand, key) in popular_brand" :key="`popular-review-${key}`" class="slides">
                    <!-- <CardPopularReview :key="`CardPopularReview-${key}`" :review-data="review" /> -->
                    <router-link
                      :to="`/brand/${currentBrand.my_soco_sql_id}/${$options.filters.slug(currentBrand.name)}`"
                    >
                      <div class="item">
                        <img
                          v-if="currentBrand.logo"
                          :src="mainImage(currentBrand.logo)"
                          :alt="currentBrand.name"
                          class="brand-logo"
                          @error="brandImageErrorHandler($event)"
                        />
                        <img v-else src="/assets/img/dummy_product.svg" class="brand-logo error-brand" alt="no image" />
                      </div>
                    </router-link>
                  </slide>
                </carousel>
              </div>
              <div v-else-if="!loading_popular_brand && popular_brand" class="list-popular-brands">
                <div v-for="(currentBrand, idx) in popular_brand" :key="idx" class="item">
                  <router-link
                    :to="`/brand/${currentBrand.my_soco_sql_id}/${$options.filters.slug(currentBrand.name)}`"
                  >
                    <img
                      v-if="currentBrand.logo"
                      :src="mainImage(currentBrand.logo)"
                      :alt="currentBrand.name"
                      class="brand-logo"
                      @error="brandImageErrorHandler($event)"
                    />
                    <img v-else src="/assets/img/dummy_product.svg" class="brand-logo error-brand" alt="no image" />
                  </router-link>
                </div>
              </div>
            </template>
          </template>
        </section>
      </article>
      <div
        v-if="
          isLoadingFinish.tryThisProducts ||
          (!isLoadingFinish.tryThisProducts && tryThisProducts.length >= 9 && isParentCategory)
        "
        class="trending trending-review section page--home"
      >
        <div v-if="!isLoadingFinish.tryThisProducts" class="header-section">
          <img
            src="/assets/img/icon-trending.svg"
            alt="Trending in soco icon"
            width="20"
            height="20"
            class="icon-header"
          />
          <h3 class="section-heading">Trending in Soco</h3>
        </div>
        <div class="lazy-pixel">
          <ListProductSlide
            key="tryThisProducts"
            class-modifier="trending--have-you-try"
            :products="tryThisProducts"
            :is-loading-finish="!isLoadingFinish.tryThisProducts"
            object_type="have_you_tried_this"
            section="have_you_tried_this"
          />
        </div>
      </div>
      <article v-if="popular_review.length > 3 || loading_review" class="popular-review">
        <GFMP v-if="loading_review" :wrapper-styles="{ width: '90%' }" :styles="{ ...fmpStyles.textHeader }" />
        <header v-else>
          <h1>Most Reviewed Products</h1>
        </header>
        <section>
          <carousel
            :per-page="isDesktop ? 3 : 1"
            :navigation-enabled="true"
            navigation-next-label
            navigation-prev-label
            pagination-color="#E5E5E5"
            pagination-active-color="#F384A7"
            class="recent-review-carousel"
          >
            <template v-if="loading_review">
              <slide v-for="i in 3 * 4" :key="i" class="slides">
                <div :style="{ padding: '0 8px' }">
                  <CardPopularReviewLoader />
                </div>
              </slide>
            </template>
            <template v-else>
              <slide v-for="(review, key) in popular_review" :key="`popular-review-${key}`" class="slides">
                <CardPopularReview :key="`CardPopularReview-${key}`" :review-data="review" />
              </slide>
            </template>
          </carousel>
        </section>
      </article>
      <template v-if="!isLogin">
        <div class="product-section__action">
          <div class="product-section__action__text">
            <p>Login dengan SOCO account dan dapatkan rekomendasi produk yang sesuai dengan beauty profilemu</p>
            <a class="btn red action p-46" @click.prevent="openLoginOtf()"> Login </a>
          </div>
        </div>
      </template>
      <!-- BP & My Interest hidden on web: https://new-sociolla.atlassian.net/browse/NON-16072 -->
      <template v-else>
        <div
          v-if="(product_you_love.length >= 9 || loading_product_you_love) && !isParentCategory"
          class="trending trending-review section"
        >
          <div v-if="!loading_product_you_love" class="header-section">
            <img src="/assets/img/icon-recommend.svg" alt="Recommend icon" />
            <div class="header-section-title">
              <h2>You Might Love This</h2>
              <p>Curated products based on your Beauty Profile</p>
            </div>
          </div>
          <div class="lazy-pixel">
            <ListProductSlide
              key="tryThisProducts"
              class-modifier="trending--have-you-try"
              :products="product_you_love"
              :is-loading-finish="!loading_product_you_love"
              object_type="have_you_tried_this"
              section="have_you_tried_this"
            />
          </div>
        </div>
      </template>
      <main v-if="isDesktop" class="category-detail-product-desktop">
        <section class="product-filter">
          <ProductFilter :parent-category="categoryIds" @sectionClick="handleSectionClick"></ProductFilter>
        </section>
        <section class="product-grid">
          <div v-if="Object.keys($route.query).length" class="container-list-filter">
            <div class="list-filter">
              <template v-for="(item, key) in Object.keys($route.query)">
                <div v-if="item === 'category'" :key="key" class="list">
                  <template v-for="(currentCategory, _key) in listCategoryItems(queryString[item])">
                    <span
                      v-if="currentCategory"
                      :key="_key"
                      class="item-list"
                      @click.prevent="onDeleteItem(item, currentCategory._id)"
                    >
                      {{ currentCategory.name }}
                      <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14" />
                    </span>
                  </template>
                </div>
                <div v-if="item === 'brands'" :key="key" class="list">
                  <template v-for="(currentBrand, _key) in listSelectedBrand(queryString[item])">
                    <span
                      v-if="currentBrand"
                      :key="_key"
                      class="item-list"
                      @click.prevent="onDeleteItem(item, currentBrand._id)"
                      >{{ currentBrand.name }} <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14"
                    /></span>
                  </template>
                </div>
                <div v-if="item === 'origins'" :key="key" class="list">
                  <template v-for="(origin, _key) in listSelectedBrandOrigin(queryString[item])">
                    <span v-if="origin" :key="_key" class="item-list" @click.prevent="onDeleteItem(item, origin._id)"
                      >{{ origin.name }} <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14"
                    /></span>
                  </template>
                </div>
                <div v-if="item === 'available_for'" :key="key" class="list">
                  <template v-for="(available, _key) in listAvailable(queryString[item])">
                    <span v-if="available" :key="_key" class="item-list" @click.prevent="onDeleteItem(item, available)"
                      >{{ available | changeAvailableName }}
                      <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14"
                    /></span>
                  </template>
                </div>
                <div v-if="item === 'tags'" :key="key" class="list">
                  <template v-for="(tag, _key) in listSelectedTags(queryString[item])">
                    <span v-if="tag" :key="_key" class="item-list" @click.prevent="onDeleteItem(item, tag._id)"
                      >{{ tag.name }} <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14"
                    /></span>
                  </template>
                </div>
                <div v-if="item === 'rating' && queryString[item]" :key="key" class="list">
                  <span class="item-list" @click.prevent="onDeleteItem(item, queryString[item])">
                    <i class="icon_star"></i> {{ parseFloat(queryString[item]).toFixed(1) }}
                    <SvgImg class="remove" name="close-charcoal-icon" width="14" height="14" />
                  </span>
                </div>
              </template>
            </div>
            <div v-if="showClearAllButton" class="list-reset">
              <span @click.prevent="reset"> Clear all </span>
            </div>
          </div>
          <ProductGrid
            :products="products"
            :title="title"
            :loading="loading"
            :lists_count="total_products"
            @infiniteHandler="infiniteHandler"
          />
        </section>
      </main>
      <main v-else class="category-detail-product-mobile">
        <section class="product-grid">
          <ProductGrid
            :products="products"
            :title="title"
            :loading="loading"
            :lists_count="total_products"
            @infiniteHandler="infiniteHandler"
          />
          <ModalFilterV2
            v-if="showModalFilterV2"
            :list_brands="$store.state.$_Category.brand"
            :list_country="$store.state.$_Category.brand_origin"
            :options="{ available: true, brands: true, rating: true, category: false }"
          />
        </section>
      </main>
    </div>
  </div>
</template>
<script>
import Auth from '@/shared/auth';
export default {
  name: 'category-details',
  components: {
    ProductGrid: () => import('@/components/v2/product-grid'),
    ProductFilter: () => import('@/components/v2/product-filter'),
    CardPopularReview: () => import('@/components/v2/snippets/card-popular-review'),
    ModalFilterV2: () => import('@/components/global/modal/modal-filter-v2'),
    ListProductSlide: () => import('@/components/dashboard/snippet/list-product-slide'),
    CardPopularReviewLoader: () => import('@/components/global/loader/card-popular-review-loader'),
  },
  data() {
    return {
      clickedSection: null,
      title: 'All Products',
      infinite: false,
      seeMoreOpen: false,
      fmpStyles: { textHeader: { borderRadius: '8px', height: '12px' } },
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.userProfile;
    },
    tryThisProducts() {
      return this.$store.state.$_Category.tryProducts;
    },
    isLoadingFinish() {
      return this.$store.state.$_Category.isLoadingFinish;
    },
    showClearAllButton() {
      return (
        this.clickedSection === 'filter' ||
        this.$route.query.category ||
        this.$route.query.brands ||
        this.$route.query.origins ||
        this.$route.query.rating ||
        this.$route.query.available_for
      );
    },
    categoryId() {
      return this.$route.params.category_id;
    },
    categoryName() {
      return this.$route.params.category_name;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    queryString() {
      return this.$store.state.$_Review.queryString;
    },
    products() {
      return this.$store.state.$_Category.product;
    },
    loading() {
      return this.$store.state.$_Category.loading;
    },
    loading_category() {
      return this.$store.state.$_Category.brand.loading;
    },
    loading_review() {
      return this.$store.state.$_Category.popular_review.loading;
    },
    loading_popular_brand() {
      return this.$store.state.$_Category.popular_brand.loading;
    },
    loading_product_you_love() {
      return this.$store.state.$_Category.productYouLove.loading;
    },
    brand() {
      return this.$store.state.$_Category.brand;
    },
    brand_origin() {
      return this.$store.state.$_Category.brand_origin;
    },
    popular_brand() {
      return this.$store.state.$_Category.popular_brand.data;
    },
    category() {
      return this.$store.state.$_Category.categories.data;
    },
    showModalFilterV2() {
      return this.$store.state.modal.isModalShow.filterV2;
    },
    total_products() {
      return this.$store.state.$_Category.total_product;
    },
    popular_review() {
      return this.$store.state.$_Category.popular_review.data;
    },
    tryProducts() {
      return this.$store.state.$_Category.tryProducts.data;
    },
    product_you_love() {
      return this.$store.state.$_Category.productYouLove.data;
    },
    isLogin() {
      return this.$SO.size(this.$store.state.auth.userProfile);
    },
    notCompletedBeautyProfile() {
      if (this.isLogin) {
        return !Boolean(this.user.beauty && this.user.beauty.length);
      }
      return true;
    },
    categoryIds() {
      const parents = this.category.parents;
      if (parents) {
        const parentsCopy = [...parents];
        parentsCopy.push(this.category._id);
        return parentsCopy;
      }
      return parents;
    },
    isParentCategory() {
      return this.category.parents && this.category.parents.length <= 2;
    },
  },
  watch: {
    'queryString.category'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.apply();
        this.getCategoryDetail();
      }
    },
    'queryString.brands'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.apply();
        this.getCategoryDetail();
      }
    },
    'queryString.origins'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.apply();
        this.getCategoryDetail();
      }
    },
    'queryString.available_for'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.apply();
        this.getCategoryDetail();
      }
    },
    'queryString.rating'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.apply();
        this.getCategoryDetail();
      }
    },
    'queryString.tags'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.apply();
        this.getCategoryDetail();
      }
    },
    '$route.query'(to, from) {
      if (to != from) {
        this.$store.dispatch('$_Review/serialize', this.$route.query);
        this.$store.commit('$_Category/SET_PRODUCT_YOU_LOVE', '');
        this.getCategoryDetail().then((category) => {
          this.$store.commit('$_Category/SET_TRENDING_REVIEW', '');
          this.$store.commit('$_Category/product_try', { data: [] });
          if (category) {
            this.getTryThisProducts(category._id);
          }
        });
      }
    },
    '$route.path'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.reset();
      }
    },
    category(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$store.commit('setPageInfo', {
          title: newVal.name,
        });
      }
    },
    queryString: {
      deep: true,
      handler(newVal) {
        for (const key in newVal) {
          if (key !== 'sort' && key !== 'limit' && key !== 'skip') {
            if (newVal[key] === '') {
              this.handleSectionClick(null);
            }
          }
        }
      },
    },
  },
  mounted() {
    this.$store.dispatch('$_Review/serialize', this.$route.query);
    this.getCategoryDetail();
    // this.getTryThisProducts();
  },
  methods: {
    handleSectionClick(section) {
      this.clickedSection = section;
    },
    async getCategoryDetail() {
      this.$store.dispatch('$_Category/getCategoryDetail', this.$route.params.category_id);
    },
    async getTryThisProducts(_id) {
      this.$store.dispatch('$_Category/getTryThisProducts', _id);
    },
    brandImageErrorHandler(e) {
      e.target.src = '/assets/img/default_img_brand.svg';
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=120',
        image: src,
      });
    },
    checkSameQueryParams(a, b) {
      const obj_1 = Object.getOwnPropertyNames(a);
      const obj_2 = Object.getOwnPropertyNames(b);

      if (obj_1.length != obj_2.length) {
        return false;
      }

      for (let i = 0; i < obj_1.length; i++) {
        const attr = obj_1[i];
        if (a[attr] !== b[attr]) {
          return false;
        }
      }

      return true;
    },
    apply() {
      let query = Object.assign({}, this.$route.query);

      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'skip',
        value: 0,
      });

      if (this.queryString.category) {
        query = Object.assign(query, { category: this.queryString.category });
        delete query.available_for;
        delete query.origins;
        delete query.rating;
        delete query.brands;
        delete query.tags;
      } else {
        if (query.category) {
          delete query.category;
        }
      }

      if (this.queryString.available_for) {
        query = Object.assign(query, { available_for: this.queryString.available_for });
      } else {
        if (query.available_for) {
          delete query.available_for;
        }
      }

      if (this.queryString.rating) {
        query = Object.assign(query, { rating: this.queryString.rating });
      } else {
        if (query.rating) {
          delete query.rating;
        }
      }

      if (this.queryString.origins) {
        query = Object.assign(query, { origins: this.queryString.origins });
      } else {
        if (query.origins) {
          delete query.origins;
        }
      }

      if (this.queryString.brands) {
        query = Object.assign(query, { brands: this.queryString.brands });
      } else {
        if (query.brands) {
          delete query.brands;
        }
      }
      if (this.queryString.tags) {
        query = Object.assign(query, { tags: this.queryString.tags });
      } else {
        if (query.tags) {
          delete query.tags;
        }
      }

      if (query.page) {
        query.page = 1;
      }

      if (!this.checkSameQueryParams(this.$route.query, query)) {
        this.$router.push({ query: query });
      }
    },
    infiniteHandler($state) {
      let skip = Number(this.queryString.skip);
      const limit = Number(this.queryString.limit);
      const newSkip = (skip += limit);
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'skip',
        value: newSkip,
      });
      this.$store
        .dispatch('$_Category/loadMoreProducts')
        .then((response) => {
          if (response.data.data && response.data.data.length) {
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch((err) => {
          $state.complete();
        });
    },
    reset() {
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'category',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'brands',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'origins',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'available_for',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'rating',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'tags',
        value: '',
      });
      this.$router.push(`/category/${this.categoryId}/${this.categoryName}`);
    },
    toggleSeeMore() {
      this.seeMoreOpen = !this.seeMoreOpen;
    },
    listSelectedBrand(item) {
      const filterBrands = [];
      const arrayItem = item.split(',');
      if (this.$store.state['$_Category'].brand.length) {
        arrayItem.map((x) => {
          const data = this.$store.state['$_Category'].brand
            .filter((xx) => xx['_id'] === x)
            .map((brand) => ({ _id: brand._id, name: brand.name }));
          if (data.length) {
            filterBrands.push(data[0]);
          }
        });
      }
      return filterBrands;
    },
    listSelectedBrandOrigin(item) {
      const filterOrigins = [];
      const arrayItem = item.split(',');
      if (this.$store.state['$_Category'].brand_origin.length) {
        arrayItem.map((x) => {
          const data = this.$store.state['$_Category'].brand_origin
            .filter((xx) => xx['country_tag_id'].toString() === x)
            .map((origin) => ({ _id: origin.country_tag_id, name: origin.country }));
          if (data.length) {
            filterOrigins.push(data[0]);
          }
        });
      }
      return filterOrigins;
    },
    listAvailable(item) {
      const arrayItem = item.split(',');
      return arrayItem;
    },
    listSelectedTags(item) {
      const filterTags = [];
      const arrayItem = item.split(',');
      const allTags = [...(this.$store.state['$_Category'].tag || [])];

      if (allTags.length) {
        arrayItem.map((x) => {
          const data = allTags.filter((xx) => xx['_id'] === x).map((tag) => ({ _id: tag._id, name: tag.name }));
          if (data.length) {
            filterTags.push(data[0]);
          }
        });
      }
      return filterTags;
    },
    listCategoryItems(item) {
      const data = this.$store.state['$_Category'].categories;
      const temp = [];
      for (const i in data) {
        temp.push({
          id_category: data[i]._id,
          link_rewrite: data[i].link_rewrite,
          name: data[i].name,
          id_parent: '',
        });
        if (data[i].children != undefined && data[i].children.length) {
          const child = data[i].children;
          for (const j in child) {
            temp.push({
              id_category: child[j]._id,
              link_rewrite: child[j].link_rewrite,
              name: child[j].name,
              id_parent: child[j].id_parent,
            });
            if (child[j].children != undefined && child[j].children.length) {
              const sub = child[j].children;
              for (const k in sub) {
                temp.push({
                  id_category: sub[k]._id,
                  link_rewrite: sub[k].link_rewrite,
                  name: sub[k].name,
                  id_parent: sub[k].id_parent,
                });
              }
            }
          }
        }
      }
      return temp.filter((xx) => xx['id_category'] === item);
    },
    onDeleteItem(item, value) {
      const queryValue = JSON.parse(JSON.stringify(this.queryString[item]));
      if (queryValue) {
        if (item === 'brands') {
          const brands = queryValue.split(',');
          const index = brands.indexOf(value);
          brands.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'brands',
            value: brands.join(','),
          });
        }
        if (item === 'origins') {
          const origins = queryValue.split(',');
          const index = origins.indexOf(value);
          origins.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'origins',
            value: origins.join(','),
          });
        }
        if (item === 'category') {
          const category = queryValue.split(',');
          const index = category.indexOf(value);
          category.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'category',
            value: category.join(','),
          });
        }
        if (item === 'available_for') {
          const available = queryValue.split(',');
          const index = available.indexOf(value);
          available.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'available_for',
            value: available.join(','),
          });
        }
        if (item === 'rating') {
          const rating = queryValue.split(',');
          const index = rating.indexOf(value);
          rating.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'rating',
            value: rating.join(','),
          });
        }
        if (item === 'tags') {
          const tags = queryValue.split(',');
          const index = tags.indexOf(value);
          tags.splice(index, 1);
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'tags',
            value: tags.join(','),
          });
        }
      }
    },
    openLoginOtf() {
      Auth.CentralAuth.login();
    },
    completeBeautyProfile() {
      this.$router.push(this.notCompletedDetailProfile ? '/register-detail' : '/beauty-profile');
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'category-detail-v2';
</style>
